// extracted by mini-css-extract-plugin
export default {"summary":"summary-module___summary___f972c243"};